// Tiny localStorage helpers for the concierge intake flow. Extracted so callers
// can import them without pulling the heavy ConciergeIntakeModal component
// (~444 LOC + framer-motion + radix dialogs) into the initial bundle.

export interface IntakeData {
  diningAtmosphere: string;
  profession: string;
  incomeRange: string;
  partnerQualities: string[];
  availability: string;
  travelWillingness: string;
  communicationPref: string;
}

const CONCIERGE_DRAFT_KEY = "concierge_draft";

export function saveConcierDraft(draft: {
  data: IntakeData;
  packageId?: string;
  packageName?: string;
}) {
  try {
    localStorage.setItem(CONCIERGE_DRAFT_KEY, JSON.stringify(draft));
  } catch {}
}

export function loadConciergeDraft():
  | { data: IntakeData; packageId?: string; packageName?: string }
  | null {
  try {
    const raw = localStorage.getItem(CONCIERGE_DRAFT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearConciergeDraft() {
  try {
    localStorage.removeItem(CONCIERGE_DRAFT_KEY);
  } catch {}
}
